import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Select, useLocalizeMessage } from 'libs.nucleus';
export var ViewMode;
(function (ViewMode) {
    ViewMode[ViewMode["SITES_VIEW"] = 0] = "SITES_VIEW";
    ViewMode[ViewMode["ICFS_VIEW"] = 1] = "ICFS_VIEW";
})(ViewMode || (ViewMode = {}));
export const ViewSelector = ({ viewMode, onViewModeChange }) => {
    const translate = useLocalizeMessage();
    const options = useMemo(() => [
        { value: String(ViewMode.SITES_VIEW), label: translate('Site'), meta: { viewMode: ViewMode.SITES_VIEW } },
        { value: String(ViewMode.ICFS_VIEW), label: translate('ICF template'), meta: { viewMode: ViewMode.ICFS_VIEW } },
    ], [translate]);
    const selectedOption = useMemo(() => options.find((option) => option.meta?.viewMode === viewMode), [options, viewMode]);
    const handleChange = useCallback((option) => {
        const mode = option.meta?.viewMode;
        if (mode !== undefined) {
            onViewModeChange(mode);
        }
    }, [onViewModeChange]);
    const arrangeByLabel = translate('Arrange by');
    return (_jsxs("div", { className: 'nucleus-flex nucleus-shrink-0 nucleus-flex-row nucleus-items-center nucleus-gap-4', "data-testid": 'site-configuration-content-view-segments', children: [_jsx("span", { className: 'nucleus-shrink-0 nucleus-font-medium nucleus-text-sm nucleus-text-text-primary', children: arrangeByLabel }), _jsx(Select, { "aria-label": arrangeByLabel, options: options, value: selectedOption, onChange: handleChange, width: 'sm', dataTestId: 'site-configuration-arrange-by-select' })] }));
};
